import "./lang_switch.scss"

